var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper"},[_c('mheader'),_c('div',{staticClass:"main-container"},[_c('router-view',{attrs:{"tag":"main"}})],1),_c('block-height')],1)}
var staticRenderFns = []

export { render, staticRenderFns }